export default {
	leads       : {},
	bulk        : [],
	isSelectAll : false,
	count       : 0,
	page        : 1,
	search      : '',
	campaigns   : [],
	tags        : [],
	stats       : {
		period : {
			start : null,
			end   : null,
		},
		dates   : {},
		change  : 0,
		current : 0,
		prior   : 0,
	},
	dateRange : {
		filter : '',
		start  : '',
		end    : '',
	},
	filterOptions : {
		campaigns : [],
		tags      : [],
	},
	filters : {
		campaign : '',
		tag      : '',
	},
	export : {
		first_name  : true,
		last_name   : true,
		email       : true,
		phone       : true,
		campaign    : true,
		site        : true,
		site_domain : true,
		page_title  : true,
		page_url    : true,
		ip          : true,
		date        : true,
		time        : true,
		type        : 'csv',
	},
	exportCount : 0,
}
